import { Injectable } from '@angular/core';
import { ItemAsset } from 'src/app/interfaces/item-asset';
import { APIProviderService } from '../api/api.provider.service';
import { ConfiguredItem } from 'src/app/interfaces/configured-item';
import { assert } from 'src/app/utils/assert.util';

@Injectable({
  providedIn: 'root'
})
export class ItemAssetsProviderService extends APIProviderService<ItemAsset> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/ItemAssets`;
  }

  private get apiControllerURL() {
    return `${this.baseURL}${this.attributeURL}`;
  }

  async getAssets(configuredItem: ConfiguredItem) {
    const url = new URL(this.apiControllerURL);
    assert(configuredItem.design, 'Design was null');
    assert(configuredItem.form, 'form was null');
    assert(configuredItem.primaryMaterial, 'primaryMaterial was null');
    assert(configuredItem.secondaryMaterial, 'secondaryMaterial was null');
    assert(configuredItem.width, 'width was null');
    url.searchParams.set('designID', configuredItem.design.id.toString());
    url.searchParams.set('formID', configuredItem.form.id.toString());
    url.searchParams.set('insideMaterialID', configuredItem.primaryMaterial.id.toString());
    url.searchParams.set('outsideMaterialID', configuredItem.secondaryMaterial.id.toString());
    url.searchParams.set('widthID', configuredItem.width.id.toString());
    const itemAssets = await this.webProvider.get<ItemAsset[]>(url.href);
    assert(itemAssets, 'Failed to fetch item assets');
    return itemAssets;
  }
}
